import { AvatarImage } from 'src/shared/design-system/Avatar';
import { ButtonColors, ButtonSizes, PrimaryButton } from 'src/shared/design-system/Buttons';
import styled from 'styled-components';
import { Font, Mixins, Spacing } from 'web-common/src/shared/styles';
import { FollowButton, FollowColorsType } from '../FollowButton';
import { closeText } from './consts';

export const Avatar = styled(AvatarImage).attrs(() => ({
  size: '100px',
}))``;

export const AvatarContainer = styled.div`
  ${Mixins.Flex.center()}
`;

export const AvatarWrapper = styled.div`
  position: relative;
`;

export const CloseButton = styled(PrimaryButton).attrs(() => ({
  children: closeText,
  size: ButtonSizes.M,
}))``;

export const FollowIcon = styled(FollowButton).attrs(() => ({
  color: ButtonColors.WHITE,
  followingColor: FollowColorsType.RED,
  isFollowing: true,
  iconOnly: true,
}))`
  position: absolute;
  pointer-events: none;
  top: -${Spacing.QUARTER};
  right: -${Spacing.QUARTER};
`;

export const FollowingText = styled.div`
  font-size: ${Font.Size.S};
  line-height: ${Font.LineHeight.S};
`;
